import { render, staticRenderFns } from "./ThePriceSection.vue?vue&type=template&id=11004047&scoped=true&name=the-price-section&"
import script from "./ThePriceSection.vue?vue&type=script&lang=js&"
export * from "./ThePriceSection.vue?vue&type=script&lang=js&"
import style0 from "./ThePriceSection.vue?vue&type=style&index=0&id=11004047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11004047",
  null
  
)

/* custom blocks */
import block0 from "./ThePriceSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports